import { PayloadAction } from "@reduxjs/toolkit";
import { FinanceState } from "../../models/FinanceState";
import { SearchCounteragentsAsClientsPayload } from "../../payload/SearchCounteragentsAsClients/SearchCounteragentsAsClientsPayload";

const searchCounteragentsAsClientsFetch = (state: FinanceState, action: PayloadAction<SearchCounteragentsAsClientsPayload>) => {
    state.isLoading = true;
}

export default searchCounteragentsAsClientsFetch;